import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { required, email } from 'vuelidate/lib/validators';
import moment from 'moment';
import { omit, map, pick } from 'lodash';
import { DIY } from '../../helpers/constants/Store';
import PageTitle from '../../components/v2/PageTitle.vue';
import BaseTextField from '../../components/v2/BaseTextField.vue';
import BaseFileInput from '../../components/v2/BaseFileInput.vue';
import DatePicker from '../../components/datepicker/Index.vue';
import ActionButton from '../../components/action_button/Index.vue';
import SignatoriesField from '../../components/v2/MerchantSignatoriesField.vue';
import BaseOverlayLoader from '../../components/v2/BaseOverlayLoader';
import FormValidationMixin from '../../helpers/vue_mixins/v2/FormValidationsMixin';
import FormMixin from '../../helpers/vue_mixins/FormMixin';
import SegmentAnalyticsMixin from '../../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import { MAX_FILE_SIZE, THIRD_PARTY_PAYMENTS_APPLICATION_LINK, MOBILE_MASK, PHONE_MASK, SHORTDATE_FORMAT, } from '../../helpers/constants/app';
import DisbursementCreate from '../../plugins/graphql/mutations/v2/disbursement-create.gql';
import DisbursementUpdate from '../../plugins/graphql/mutations/v2/disbursement-update.gql';
import DisbursementSignatoryCreate from '../../plugins/graphql/mutations/v2/disbursement-signatory-create.gql';
import DisbursementSignatoryUpdate from '../../plugins/graphql/mutations/v2/disbursement-signatory-update.gql';
import DisbursementSignatoryDelete from '../../plugins/graphql/mutations/v2/disbursement-signatory-delete.gql';
import DisbursementAttachFile from '../../plugins/graphql/mutations/v2/disbursement-attach-file.gql';
import AppDisbursementQuery from '../../plugins/graphql/queries/v2/app-disbursement.gql';
import AlertMixin from '../../helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '../../helpers/vue_mixins/ButtonLoaderMixin';
import RouterParamsAppMixin from '../../helpers/vue_mixins/RouterParamsAppMixin';
import ViewportSizeMixin from '../../helpers/mixins/ViewportSizeMixin';
const sizeValidator = (file) => {
    if (file) {
        return file.size < MAX_FILE_SIZE;
    }
    return true;
};
let MerchantPaymentRegistration = class MerchantPaymentRegistration extends Mixins(FormValidationMixin, FormMixin, SegmentAnalyticsMixin, AlertMixin, Mixins(ButtonLoaderMixin, RouterParamsAppMixin, ViewportSizeMixin)) {
    constructor() {
        super(...arguments);
        this.signatoriesFields = [];
        this.disbursementUuid = null;
        this.form = {
            agreedToTerms: false,
            email: '',
            businessName: '',
            businessAddress: '',
            postalCode: '',
            tin: '',
            vatable: true,
            phoneNumber: '',
            mobileNumber: '',
            businessType: '',
            businessNature: [],
            establishedDate: '',
            bankName: '',
            bankAccountName: '',
            bankBranch: '',
            bankNumber: '',
        };
        this.disbursementAttachments = {
            companyProfileFilename: '',
            birFilename: '',
            dtiFilename: '',
            governmentIdFilename: '',
            businessPermitFilename: '',
            companyProfileUrl: '',
            birUrl: '',
            dtiUrl: '',
            governmentIdUrl: '',
            businessPermitUrl: '',
        };
        this.companyProfile = null;
        this.bir = null;
        this.governmentId = null;
        this.dti = null;
        this.businessPermit = null;
        this.removedSignatories = [];
    }
    get mobileMask() {
        return MOBILE_MASK;
    }
    get phoneMask() {
        return PHONE_MASK;
    }
    get defaultSignatoryField() {
        return {
            mobileNumber: '',
            fullName: '',
            position: '',
            uuid: '',
        };
    }
    get defaultSignatory() {
        return {
            ...this.defaultSignatoryField,
            // used to bind unique v-models in form
            key: this.signatoriesFields.length,
        };
    }
    get vatOptions() {
        return [
            { value: true, label: 'VAT' },
            { value: false, label: 'Non-VAT' },
        ];
    }
    // TODO: use graphql if available
    get businessTypes() {
        return [
            { text: 'Single/Sole Proprietor', value: 'Single/Sole Proprietor' },
            { text: 'Service', value: 'Service' },
            { text: 'Merchandising', value: 'Merchandising' },
            { text: 'Partnership', value: 'Partnership' },
            { text: 'Single/Sole Proprietor', value: 'Single/Sole Proprietor' },
            { text: 'Corporation', value: 'Corporation' },
        ];
    }
    // TODO: use graphql if available
    get businessNatures() {
        return [
            { text: 'Wholesaler', value: 'Wholesaler' },
            { text: 'Retailer', value: 'Retailer' },
            { text: 'Reseller', value: 'Reseller' },
            { text: 'Distributor', value: 'Distributor' },
            { text: 'Grocery Stores', value: 'Grocery Stores' },
        ];
    }
    get businessNature() {
        return this.form.businessNature.join(',');
    }
    // TODO: find a way to prevent watching of query after saving form
    get signatories() {
        const signatories = this.signatoriesFields.filter((signatory) => !signatory.uuid && signatory.fullName && signatory.position && signatory.mobileNumber);
        return signatories.map((signatory) => omit(signatory, ['key', 'uuid']));
    }
    get updatedSignatories() {
        const signatories = this.signatoriesFields.filter(({ uuid }) => uuid);
        return {
            signatoryUuids: map(signatories, 'uuid'),
            signatoryInputs: map(signatories, (signatory) => omit(signatory, ['key', 'uuid', '__typename'])),
        };
    }
    get disbursementForm() {
        const form = {
            ...this.form,
            businessNature: this.businessNature,
            appUuid: this.appUUID,
        };
        return omit(form, ['agreedToTerms']);
    }
    fileName(file) {
        return (!!file && file.name) || null;
    }
    generateSignatory() {
        this.signatoriesFields.push(this.defaultSignatory);
    }
    onRemoveSignatory(index, uuid) {
        if (uuid) {
            this.removedSignatories.push(uuid);
        }
        this.signatoriesFields.splice(index, 1);
    }
    onRemoveNatureOfBusiness(removedText) {
        this.form.businessNature = this.form.businessNature.filter((text) => text !== removedText);
    }
    async createSignatories(disbursementUuid) {
        if (this.signatories.length) {
            await this.$apollo.mutate({
                mutation: DisbursementSignatoryCreate,
                variables: {
                    input: {
                        disbursementUuid,
                        signatoryInputs: this.signatories,
                    },
                },
            });
        }
    }
    async updateSignatories() {
        if (this.updatedSignatories.signatoryUuids.length) {
            await this.$apollo.mutate({
                mutation: DisbursementSignatoryUpdate,
                variables: {
                    input: this.updatedSignatories,
                },
            });
        }
    }
    async removeSignatories() {
        if (this.removedSignatories.length) {
            await this.$apollo.mutate({
                mutation: DisbursementSignatoryDelete,
                variables: {
                    input: {
                        signatoryUuids: this.removedSignatories,
                    },
                },
            });
        }
    }
    sameFile(currentFile, filename) {
        if (currentFile) {
            return currentFile.name === filename ? null : [currentFile];
        }
        return null;
    }
    async attachFile(disbursementUuid) {
        await this.$apollo
            .mutate({
            mutation: DisbursementAttachFile,
            variables: {
                input: {
                    // Multipart accepts array
                    companyProfile: this.sameFile(this.companyProfile, this.disbursementAttachments.companyProfileFilename),
                    bir: this.sameFile(this.bir, this.disbursementAttachments.birFilename),
                    governmentId: this.sameFile(this.governmentId, this.disbursementAttachments.governmentIdFilename),
                    dti: this.sameFile(this.dti, this.disbursementAttachments.dtiFilename),
                    businessPermit: this.sameFile(this.businessPermit, this.disbursementAttachments.businessPermitFilename),
                    disbursementUuid,
                },
            },
        })
            .then(() => {
            this.successNotification('Form Submitted');
            this.requestDone();
            this.$router.go(-1);
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.requestDone();
        });
    }
    onSaveForm() {
        const mutationParams = {
            mutation: DisbursementCreate,
            variables: { input: this.disbursementForm },
        };
        if (this.disbursementUuid) {
            Object.assign(mutationParams, {
                mutation: DisbursementUpdate,
                variables: {
                    input: {
                        ...omit(this.disbursementForm, ['appUuid']),
                        disbursementUuid: this.disbursementUuid,
                    },
                },
            });
        }
        return this.$apollo.mutate(mutationParams);
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            this.onSaveForm()
                .then(({ data }) => {
                const uuid = this.disbursementUuid || data.disbursementCreate.disbursement.uuid;
                this.updateSignatories();
                this.removeSignatories();
                this.createSignatories(uuid);
                this.attachFile(uuid);
            })
                .catch((e) => {
                this.errorNotification(e.message);
                this.requestDone();
            });
        }
    }
    urlObject(file) {
        return !file ? '' : URL.createObjectURL(file);
    }
    redirectToGoogleForm() {
        window.open(THIRD_PARTY_PAYMENTS_APPLICATION_LINK, '_blank');
    }
    mounted() {
        this.segmentTrack('Chatgenie Website Visit');
    }
};
__decorate([
    Mutation('showTerms', { namespace: DIY })
], MerchantPaymentRegistration.prototype, "showTerms", void 0);
MerchantPaymentRegistration = __decorate([
    Component({
        apollo: {
            disbursementUuid: {
                query: AppDisbursementQuery,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update({ fetchAppByUuid }) {
                    const { disbursement } = fetchAppByUuid;
                    if (disbursement) {
                        const attachmentsKeys = Object.keys(disbursement).filter((key) => {
                            return /Filename/.test(key) || /Url/.test(key);
                        });
                        this.disbursementAttachments = pick(disbursement, attachmentsKeys);
                        this.form = Object.assign(this.form, {
                            ...omit(disbursement, [
                                'signatories',
                                'uuid',
                                '__typename',
                                'status',
                                ...attachmentsKeys,
                            ]),
                            businessNature: disbursement.businessNature.split(','),
                            establishedDate: moment(disbursement.establishedDate).format(SHORTDATE_FORMAT),
                        });
                        if (!disbursement.signatories.length) {
                            this.generateSignatory();
                        }
                        else {
                            this.signatoriesFields = disbursement.signatories;
                        }
                        return disbursement.uuid;
                    }
                    this.generateSignatory();
                    return null;
                },
            },
        },
        validations() {
            return {
                companyProfile: {
                    required: () => true,
                    maxFileSizeExceeded: sizeValidator,
                },
                bir: {
                    required: () => {
                        if (!this.$data.bir && this.$data.disbursementUuid) {
                            return true;
                        }
                        return !!this.$data.bir;
                    },
                    maxFileSizeExceeded: sizeValidator,
                },
                governmentId: {
                    required: () => true,
                    maxFileSizeExceeded: sizeValidator,
                },
                dti: {
                    required: () => {
                        if (!this.$data.dti && this.$data.disbursementUuid) {
                            return true;
                        }
                        return !!this.$data.dti;
                    },
                    maxFileSizeExceeded: sizeValidator,
                },
                businessPermit: {
                    required: () => true,
                    maxFileSizeExceeded: sizeValidator,
                },
                form: {
                    email: { required, email },
                    businessName: { required },
                    businessAddress: { required },
                    postalCode: { required },
                    tin: { required },
                    phoneNumber: { required },
                    mobileNumber: { required },
                    businessType: { required },
                    businessNature: { required },
                    establishedDate: { required },
                    bankName: { required },
                    bankAccountName: { required },
                    bankBranch: { required },
                    bankNumber: { required },
                },
                signatoriesFields: {
                    $each: {
                        mobileNumber: {
                            required,
                            unique(value) {
                                const match = this.$data.signatoriesFields.filter((signatory) => signatory.mobileNumber === value);
                                return match.length <= 1;
                            },
                        },
                        position: { required },
                        fullName: { required },
                        uuid: {},
                    },
                },
            };
        },
        components: {
            PageTitle,
            BaseTextField,
            BaseFileInput,
            DatePicker,
            ActionButton,
            SignatoriesField,
            BaseOverlayLoader,
            TermsAndConditions: () => import('../../components/v2/diy/TheDiyTerms.vue'),
        },
    })
], MerchantPaymentRegistration);
export default MerchantPaymentRegistration;
